import { render, staticRenderFns } from "./FixedBottomSaveButton.vue?vue&type=template&id=0068af33&scoped=true"
import script from "./FixedBottomSaveButton.vue?vue&type=script&lang=js"
export * from "./FixedBottomSaveButton.vue?vue&type=script&lang=js"
import style0 from "./FixedBottomSaveButton.vue?vue&type=style&index=0&id=0068af33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0068af33",
  null
  
)

export default component.exports